
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-router-prompt.cjs.production.min.js')
} else {
  module.exports = require('./react-router-prompt.cjs.development.js')
}
